/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The DbGetRequest model module.
 * @module model/DbGetRequest
 * @version 1.0.0
 */
export default class DbGetRequest {
  /**
   * Constructs a new <code>DbGetRequest</code>.
   * @alias module:model/DbGetRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>DbGetRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DbGetRequest} obj Optional instance to populate.
   * @return {module:model/DbGetRequest} The populated <code>DbGetRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DbGetRequest();
      if (data.hasOwnProperty('collectionName'))
        obj.collectionName = ApiClient.convertToType(data['collectionName'], 'String');
      if (data.hasOwnProperty('query'))
        obj.query = ApiClient.convertToType(data['query'], Object);
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('sort'))
        obj.sort = data['sort'];
      if (data.hasOwnProperty('limit'))
        obj.limit = ApiClient.convertToType(data['limit'], 'Number');
      if (data.hasOwnProperty('skip'))
        obj.skip = ApiClient.convertToType(data['skip'], 'Number');
      if (data.hasOwnProperty('projection'))
        obj.projection = ApiClient.convertToType(data['projection'], Object);
    }
    return obj;
  }
}

/**
 * @member {String} collectionName
 */
DbGetRequest.prototype.collectionName = undefined;

/**
 * @member {Object} query
 */
DbGetRequest.prototype.query = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
DbGetRequest.TypeEnum = {
  findOne: "findOne",
  findMany: "findMany",
  count: "count"
};
/**
 * @member {module:model/DbGetRequest.TypeEnum} type
 */
DbGetRequest.prototype.type = undefined;

/** @member {Array} sort - pymongo sort spec, e.g. [["dateIso", -1]] */
DbGetRequest.prototype.sort = undefined;
/** @member {Number} limit */
DbGetRequest.prototype.limit = undefined;
/** @member {Number} skip */
DbGetRequest.prototype.skip = undefined;
/** @member {Object} projection */
DbGetRequest.prototype.projection = undefined;

